import React from "react";
import Collapsible from "react-collapsible";
import { isMobileOnly } from "react-device-detect";
import { Link } from "gatsby";
import Image from "gatsby-image";
import { getImage } from "~/helpers";
import {
    HeadingLarge,
    BodyText,
    BodyTextAlt,
} from "~/components/.base/headings";
import { Grid, Row, Col, FlexBox } from "~/components/.base/containers";
import Location from "./Location";
import lighthouse from "~/images/locations/lighthouse.png";
import FoodTruckIcon from "~/images/icons/food_truck.svg";
import ForkKnifeIcon from "~/images/icons/fork_knife.svg";
import "./LocationList.scss";

const LocationList = ({ locationColumns, bgImages }) => {
    if (!locationColumns.length) return <div />;
    return (
        <div className="location-list" id="location-list">
            <Image
                fluid={getImage(bgImages, "blurred_smudge_2")}
                alt="map background"
                className="map-background"
            />
            <HeadingLarge className="tc">
                Search{" "}
                <span className="red">
                    By
                    <br /> State
                </span>
            </HeadingLarge>
            {isMobileOnly ? (
                <div className="mobile-state-list">
                    {locationColumns
                        .find((col) => col.title === "Col 1")
                        .foodTruckStates.map((state, i) => (
                            <Collapsible key={i} trigger={state.title}>
                                {state.foodTrucks.map((truck, i) => (
                                    <Link
                                        key={i}
                                        to={`/locations/details/${truck.handle}`}
                                    >
                                        <FlexBox className="mobile-truck">
                                            {truck.isATruck ? (
                                                <FoodTruckIcon />
                                            ) : (
                                                <ForkKnifeIcon />
                                            )}
                                            <div>
                                                <BodyTextAlt>
                                                    {truck.title}
                                                </BodyTextAlt>
                                                <BodyText>
                                                    {truck.isATruck
                                                        ? "Truck"
                                                        : "Restaurant"}
                                                </BodyText>
                                            </div>
                                        </FlexBox>
                                    </Link>
                                ))}
                            </Collapsible>
                        ))}
                    {locationColumns
                        .find((col) => col.title === "Col 2")
                        .foodTruckStates.map((state, i) => (
                            <Collapsible key={i} trigger={state.title}>
                                {state.foodTrucks.map((truck, i) => (
                                    <Link
                                        key={i}
                                        to={`/locations/details/${truck.handle}`}
                                    >
                                        <FlexBox className="mobile-truck">
                                            {truck.isATruck ? (
                                                <FoodTruckIcon />
                                            ) : (
                                                <ForkKnifeIcon />
                                            )}
                                            <div>
                                                <BodyTextAlt>
                                                    {truck.title}
                                                </BodyTextAlt>
                                                <BodyText>
                                                    {truck.isATruck
                                                        ? "Truck"
                                                        : "Restaurant"}
                                                </BodyText>
                                            </div>
                                        </FlexBox>
                                    </Link>
                                ))}
                            </Collapsible>
                        ))}
                    {locationColumns
                        .find((col) => col.title === "Col 3")
                        .foodTruckStates.map((state, i) => (
                            <Collapsible key={i} trigger={state.title}>
                                {state.foodTrucks.map((truck, i) => (
                                    <Link
                                        key={i}
                                        to={`/locations/details/${truck.handle}`}
                                    >
                                        <FlexBox className="mobile-truck">
                                            {truck.isATruck ? (
                                                <FoodTruckIcon />
                                            ) : (
                                                <ForkKnifeIcon />
                                            )}
                                            <div>
                                                <BodyTextAlt>
                                                    {truck.title}
                                                </BodyTextAlt>
                                                <BodyText>
                                                    {truck.isATruck
                                                        ? "Truck"
                                                        : "Restaurant"}
                                                </BodyText>
                                            </div>
                                        </FlexBox>
                                    </Link>
                                ))}
                            </Collapsible>
                        ))}
                    {locationColumns
                        .find((col) => col.title === "Col 4")
                        .foodTruckStates.map((state, i) => (
                            <Collapsible key={i} trigger={state.title}>
                                {state.foodTrucks.map((truck, i) => (
                                    <Link
                                        key={i}
                                        to={`/locations/details/${truck.handle}`}
                                    >
                                        <FlexBox className="mobile-truck">
                                            {truck.isATruck ? (
                                                <FoodTruckIcon />
                                            ) : (
                                                <ForkKnifeIcon />
                                            )}
                                            <div>
                                                <BodyTextAlt>
                                                    {truck.title}
                                                </BodyTextAlt>
                                                <BodyText>
                                                    {truck.isATruck
                                                        ? "Truck"
                                                        : "Restaurant"}
                                                </BodyText>
                                            </div>
                                        </FlexBox>
                                    </Link>
                                ))}
                            </Collapsible>
                        ))}
                </div>
            ) : (
                <Grid className="location-grid">
                    <Row className="location-row">
                        <Col size={1} pd="40px">
                            {locationColumns
                                .find((col) => col.title === "Col 1")
                                .foodTruckStates.map((state, i) => (
                                    <Location
                                        key={i}
                                        state={state.title}
                                        items={state.foodTrucks}
                                    />
                                ))}
                        </Col>
                        <Col size={1} pd="40px">
                            {locationColumns
                                .find((col) => col.title === "Col 2")
                                .foodTruckStates.map((state, i) => (
                                    <Location
                                        key={i}
                                        state={state.title}
                                        items={state.foodTrucks}
                                    />
                                ))}
                        </Col>
                        <Col size={1} pd="40px">
                            {locationColumns
                                .find((col) => col.title === "Col 3")
                                .foodTruckStates.map((state, i) => (
                                    <Location
                                        key={i}
                                        state={state.title}
                                        items={state.foodTrucks}
                                    />
                                ))}
                        </Col>
                        <Col size={1} pd="40px">
                            {locationColumns
                                .find((col) => col.title === "Col 4")
                                .foodTruckStates.map((state, i) => (
                                    <Location
                                        key={i}
                                        state={state.title}
                                        items={state.foodTrucks}
                                    />
                                ))}
                        </Col>
                    </Row>
                </Grid>
            )}
            <div className="img-cont lighthouse">
                <img src={lighthouse} alt="lighthouse" />
            </div>
        </div>
    );
};
export default LocationList;
